// extracted by mini-css-extract-plugin
module.exports = {"tagLine":"TagLine_tagLine__1PPxv","minimized":"TagLine_minimized__3W0nz"};